import React from 'react';
import { Paper, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import Flex from 'ui/Flex/Flex';
import styled from '@mui/system/styled';
import { containerStyle } from 'components/SharedComponents/HighlightContainer/helpers';

const StyPaper = styled(Paper, {
    name: 'StyPaper',
})<{ bgColor: keyof Theme['palette']; fullWidth: boolean }>(
    ({ theme, bgColor, elevation, fullWidth }) => ({
        height: 'auto',
        ...containerStyle,
        backgroundColor: theme.palette[bgColor].background,
        elevation: elevation,
        width: fullWidth ? '100%' : 'auto',
        alignContent: 'center',
    }),
);

type Props = {
    title: string;
    children: React.ReactNode;
    textColor?: keyof Theme['palette'];
    bgColor?: keyof Theme['palette'];
    elevation?: number;
    fullWidth?: boolean;
};

export const HighlightPaper = ({
    title,
    children,
    textColor = 'text',
    elevation = 0,
    bgColor = 'primary',
    fullWidth = false,
}: Props) => {
    return (
        <StyPaper bgColor={bgColor} elevation={elevation} fullWidth={fullWidth}>
            <Flex>
                <Typography
                    variant="h5"
                    sx={{
                        padding: '1em',
                        color: `${textColor}.main`,
                        alignContent: 'center',
                    }}
                >
                    {title}
                </Typography>
                <Flex gap={1} alignItems="center" wrap="wrap">
                    {children}
                </Flex>
            </Flex>
        </StyPaper>
    );
};
